<adf-login-alden
  #login
  [copyrightText]="'application.copyright' | adfAppConfig | translate : { year: currentYear }"
  providers="ECM"
  [successRoute]="'landingPage' | adfAppConfig"
  [logoImageUrl]="'application.login_logo' | adfAppConfig"
  [backgroundImageUrl]="'application.login_background' | adfAppConfig"
  [showRememberMe]="false"
  [showLoginActions]="false"
  (executeSubmit)="onFormSubmit($event)"
>
</adf-login-alden>